var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.08,13.3l2.41,1.98c0.16,0.13,0.41,0.02,0.41-0.19v-3.97c0-0.21-0.25-0.33-0.41-0.19l-2.41,1.98 C-0.04,13.02-0.04,13.2,0.08,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.91,13.3l-2.41,1.98c-0.16,0.13-0.41,0.02-0.41-0.19v-3.97c0-0.21,0.25-0.33,0.41-0.19l2.41,1.98 C26.03,13.02,26.03,13.2,25.91,13.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.39,7.45v11.09H5.61V7.45H20.39 M21.07,5.77H4.93c-0.55,0-1,0.45-1,1v12.45c0,0.55,0.45,1,1,1h16.14c0.55,0,1-0.45,1-1 V6.77C22.07,6.22,21.62,5.77,21.07,5.77L21.07,5.77z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.45,8.77c-0.83,0-1.5,0.67-1.5,1.5c0,0.83,0.67,1.5,1.5,1.5c0.83,0,1.5-0.67,1.5-1.5C18.95,9.44,18.28,8.77,17.45,8.77 L17.45,8.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "7.13,18.26 11.7,13.68 16.28,18.26  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,14.93l2.44,2.44H9.27L11.7,14.93 M11.7,12.52c-0.06,0-0.13,0.02-0.18,0.07l-6.54,6.55h13.43l-6.54-6.55 C11.83,12.55,11.77,12.52,11.7,12.52L11.7,12.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "12.62,18.43 15.99,15.05 19.36,18.43  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99,15.98l1.79,1.8H14.2L15.99,15.98 M15.99,14.23c-0.06,0-0.13,0.02-0.18,0.07l-4.76,4.78h9.88l-4.76-4.78 C16.12,14.26,16.05,14.23,15.99,14.23L15.99,14.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.45,21.36c-0.55,0-1,0.45-1,1s0.45,1,1,1c0.55,0,1-0.45,1-1S10,21.36,9.45,21.36L9.45,21.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.55,21.36c-0.55,0-1,0.45-1,1s0.45,1,1,1c0.55,0,1-0.45,1-1S17.1,21.36,16.55,21.36L16.55,21.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,21.36c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S13.55,21.36,13,21.36L13,21.36z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSlider);
export default __webpack_public_path__ + "static/media/ImageSlider.a743471ce88bed0aa10a9b950477aa91.svg";
export { ForwardRef as ReactComponent };